"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/site-menu/component");
const component_2 = require("@front/layouts/default-layout/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="project-list-page">
    <div class="text-right mb-3">
        <button type="button" class="btn btn-secondary" @click="${x => x.backToKnowledge()}">
          <i class="fas fa-arrow-left"></i> ${'common.back'.t()}
        </button>
    </div>

    
    <crud-table :isItemUneditable="${x => x.isProjectUneditable}" :forceItemEditable="${x => x.forceProjectEditable}"
      title="${'project.list'.t()}" addText="${'project.create'.t()}" resource="project" searchPlaceholder="Search projects..."
      indexEndpoint="project.index" listEndpoint="project.list" deleteEndpoint="project.delete"
      editRoute="/ai/knowledge/project/edit/:id" addRoute="/ai/knowledge/project/create" :columns="${x => x.tableColumns}">
    </crud-table>
  </div>
</div>
`;
const styles = null;
const shadowOptions = { "mode": "open" };
let ProjectList = class ProjectList extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.tableColumns = [
            { key: 'name', header: 'project.name'.t() },
            {
                key: 'description',
                header: 'project.description'.t(),
                formatter: (value) => value ? (value.length > 100 ? value.substring(0, 100) + '...' : value) : '-'
            },
            {
                key: 'color',
                header: 'project.color'.t(),
                formatter: (color) => {
                    if (!color)
                        return '-';
                    return `<span class="badge" style="background-color: ${color}; color: white;">${color}</span>`;
                }
            }
        ];
    }
    async connectedCallback() {
        var _a, _b, _c;
        const isSuperAdmin = ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        const isParentUser = ((_b = component_2.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER || ((_c = component_2.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
        if (!isSuperAdmin) {
            // Regular users can only edit/delete their own projects
            this.forceProjectEditable = (key, row) => {
                var _a;
                if (!row.createdBy) {
                    return false;
                }
                return row.createdBy.id === ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.id);
            };
        }
        if (isSuperAdmin) {
            // Add owner column for super admins
            this.tableColumns.push({
                key: 'createdBy',
                header: 'project.creator'.t(),
                formatter: (creator) => creator ? `<a class="creator-link" data-id="${creator.id}" href="/user/list/${creator.id}">${creator.name}</a>` : '-'
            });
        }
        super.connectedCallback();
    }
    backToKnowledge() {
        component_1.SiteMenu.goto.bind(this)('/ai/knowledge/list');
    }
};
exports.ProjectList = ProjectList;
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], ProjectList.prototype, "isProjectUneditable", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], ProjectList.prototype, "forceProjectEditable", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ProjectList.prototype, "tableColumns", void 0);
exports.ProjectList = ProjectList = __decorate([
    (0, client_1.RWSView)('project-list', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], ProjectList);
ProjectList.defineComponent();
